/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaRangeOutput
 */
export interface StringCriteriaRangeOutput {
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaRangeOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeOutput
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRangeOutput
     */
    to?: string | null;
}

export function StringCriteriaRangeOutputFromJSON(json: any): StringCriteriaRangeOutput {
    return StringCriteriaRangeOutputFromJSONTyped(json, false);
}

export function StringCriteriaRangeOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaRangeOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function StringCriteriaRangeOutputToJSON(value?: StringCriteriaRangeOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from,
        'to': value.to,
    };
}


